import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	currentStep: 0,
	form: {},
	isCurrentPageValid: false,
	isReplaceable: false,
	isFflNumberValid: false,
	isCheckboxChecked: false,
}

const slice = createSlice({
	name: 'wizard',
	initialState,
	reducers: {
		resetCurrentStep(state, action) {
			state.currentStep = initialState.currentStep
		},
		nextClicked(state, action) {
			state.currentStep = state.currentStep + 1
		},
		backClicked(state, action) {
			state.currentStep = state.currentStep - 1
		},
		setIsCurrentPageValid(state, action) {
			state.isCurrentPageValid = action.payload
		},
		setFormValues(state, action) {
			state.form = { ...state.form, ...action.payload }
		},
		setIsCheckboxChecked(state, action) {
			state.isCheckboxChecked = action.payload
		},
		resetFormValues(state, action) {
			state.form = initialState.form
		},
		setIsReplaceable(state, action) {
			state.isReplaceable = action.payload
		},
		setIsFflNumberValid(state, action) {
			state.isFflNumberValid = action.payload || initialState.isFflNumberValid
		},
	},
})
export default slice
export const { name, actions, reducer } = slice
